@if (androidInstallUrl) {
  <a class="store-badges__link" [href]="androidInstallUrl" target="_blank" rel="noopener">
    <img class="store-badges__image store-badges__image--google"
         src="assets/store-badges/google-play-en-us.svg"
         [alt]="googleBadgeAlt" />
  </a>
}
@if (iosInstallUrl) {
  <a class="store-badges__link" [href]="iosInstallUrl" target="_blank" rel="noopener">
    <img class="store-badges__image store-badges__image--apple"
         src="assets/store-badges/apple-download-en-us.svg"
         [alt]="appleBadgeAlt" />
  </a>
}
